import { makeApi } from "@zodios/core";
import { z } from "zod";

export const backofficeVxApi = makeApi([
  {
    method: "put",
    path: "/device/site/:siteId/gateway/:serialNumber/update",
    alias: "updateMomboxVersion",
    parameters: [
      {
        type: "Path",
        schema: z.number(),
        name: "siteId",
      },
      {
        type: "Path",
        schema: z.string(),
        name: "serialNumber",
      },
    ],
    response: z.any(),
  },
]);
